import { render, staticRenderFns } from "./MusicColumn.vue?vue&type=template&id=0afafc42&scoped=true&"
import script from "./MusicColumn.vue?vue&type=script&lang=js&"
export * from "./MusicColumn.vue?vue&type=script&lang=js&"
import style0 from "./MusicColumn.vue?vue&type=style&index=0&id=0afafc42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afafc42",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VDialog,VIcon})
